import {createFileRoute} from '@tanstack/react-router';

import {LearningPage} from '@/modules/learning/pages/LearningPage';

export const Route = createFileRoute('/_authenticated/learning/')({
  component: LearningPage,
});
